<span *ngIf="currency" [ngbTooltip]="currency.name + '(' + currency.code + ')'" container="body">
  {{ currency?.symbol }}
</span>
